import React from "react";
import StarBorderRoundedIcon from "@mui/icons-material/StarBorderRounded";
import { PREQUAL_COLORS } from "../constants";

interface IPrequalStatusPillProps {
  label: string;
}

// Gold status pill with star shown above the check circle ("PRE-APPROVED" on
// the eligible result, "PRE-QUALIFIED" on the annual-only/already-qualified
// states) — Figma 36641-16534.
export const PrequalStatusPill = ({ label }: IPrequalStatusPillProps) => (
  <span
    className="flex items-center gap-1.5 rounded-full border px-4 py-1.5
      text-[11px] font-semibold tracking-wide text-black"
    style={{ borderColor: PREQUAL_COLORS.gold, backgroundColor: PREQUAL_COLORS.cream }}
  >
    <StarBorderRoundedIcon sx={{ fontSize: 14 }} />
    {label}
  </span>
);
